import {View} from 'backbone.marionette';

class BrandSelect extends View.extend({
}) {
  render() {}
}

export default BrandSelect;
